module.exports = __webpack_public_path__ + "static/SuisseIntl-Thin-fdb6c6b4fab01bacc8dd79a16bda8fbc.woff";